export default __webpack_public_path__ + "static/media/IMG_1979.52c743ab.JPG";